import axiosConfig from "./axiosConfig";

class AnneUniversitaireService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/anneuniv");
            return response.data || { data: [] };
        } catch (error) {
            console.error("Error fetching anne_universitaire:", error);
            return { data: [] };
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/anneuniv", formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la création:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.put(`/anneuniv/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la mise à jour:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/anneuniv/${id}`);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la suppression:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const AnneUniversitaireServiceInstance = new AnneUniversitaireService();
export default AnneUniversitaireServiceInstance;